import firebase from "firebase/compat/app";
import { useState, useEffect } from "react";
// import { getAnalytics } from "firebase/analytics";
import "firebase/compat/storage"
import {createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, signOut, GoogleAuthProvider, sendEmailVerification ,signInWithPopup} from "firebase/auth"
import { getAuth } from "firebase/auth"
import { sendPasswordResetEmail as firebaseSendPasswordResetEmail } from "firebase/auth";
import 'firebase/compat/firestore';
import { getFirestore, setDoc } from "firebase/firestore";
import { getStorage, ref, listAll, deleteObject, uploadString, uploadBytes, getDownloadURL } from "firebase/storage";
import i18n from "./i18nextConf";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  authDomain: "facadewebapp.firebaseapp.com",
  projectId: "facadewebapp",
  storageBucket: "facadewebapp.appspot.com",
  messagingSenderId: "922098604172",
  appId: "1:922098604172:web:63582ed27866fc40ad43a9",
  measurementId: "G-NGH80G7BMD"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
const auth = getAuth();
if (i18n.isInitialized) {
 
  auth.languageCode = i18n.language;
} else {
  i18n.on('initialized', () => {
  
    auth.languageCode = i18n.language;
  });
}
const db = getFirestore();

// ✅ Connect to Firebase emulators in development mode
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log('🔧 Connecting to Firebase emulators...');
  const { connectFirestoreEmulator } = require('firebase/firestore');
  const { connectAuthEmulator } = require('firebase/auth');
  const { connectStorageEmulator } = require('firebase/storage');
  
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('✅ Connected to Firebase emulators');
  } catch (error) {
    console.warn('⚠️ Could not connect to emulators:', error.message);
  }
}

// One-time listener: sign out any guest user on page load/refresh.
// This ensures the app doesn't keep a "guest_" session across refreshes.
let _unsubGuestLogout;
_unsubGuestLogout = onAuthStateChanged(auth, (user) => {
  try {
    if (user && user.email && user.email.startsWith('guest_')) {
      // sign out guest immediately
      signOut(auth).catch((err) => console.error('Error signing out guest on refresh:', err));
    }
  } finally {
    // unsubscribe the one-time listener
    if (_unsubGuestLogout) _unsubGuestLogout();
  }
});

function signup(email, password){
  return createUserWithEmailAndPassword(auth, email, password);
  
}

function login(email, password){
  return signInWithEmailAndPassword(auth, email, password);
  
}

export async function googleSignIn() {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider);
}

export const sendPasswordResetEmail = (email) => {
  return firebaseSendPasswordResetEmail(auth, email, {
    url: "https://facadewebapp.com/?login=true",
  });
};

export const sendVerificationEmail = (actionCodeSettings) => {
  const currentUser = auth.currentUser;

  if (currentUser) {
    return sendEmailVerification(currentUser, actionCodeSettings);
  } else {
    return Promise.reject(new Error("No user is signed in."));
  }
};

export const getEmailVerificationRedirectUrl = () => {
  const configuredUrl = process.env.REACT_APP_EMAIL_VERIFICATION_REDIRECT_URL;
  if (configuredUrl) {
    return configuredUrl;
  }

  return "https://facadewebapp.com/?emailVerified=true";
};


export {listAll, setDoc, ref, getStorage, storage, auth, signup, login, db, getDownloadURL, deleteObject, uploadString, uploadBytes,  firebase as default};
// const analytics = getAnalytics(app);

export function logout(){
return signOut(auth);
}

// custom hook

const shouldExposeAuthenticatedUser = (user) => {
  if (!user) {
    return false;
  }

  if (user.email?.startsWith('guest_')) {
    return true;
  }

  return Boolean(user.emailVerified);
};

export function useAuth() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const syncUserState = async (forceReload = false) => {
      const user = auth.currentUser;

      if (!user) {
        setCurrentUser(null);
        return;
      }

      if (forceReload && !user.email?.startsWith('guest_')) {
        try {
          await user.reload();
        } catch (error) {
          console.warn('Failed to reload auth user during cross-tab sync:', error);
        }
      }

      setCurrentUser(shouldExposeAuthenticatedUser(auth.currentUser) ? auth.currentUser : null);
    };

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setCurrentUser(null);
        return;
      }

      setCurrentUser(shouldExposeAuthenticatedUser(user) ? user : null);
    });

    const handleStorageChange = (event) => {
      if (event.key === 'facade_email_verified' && event.newValue) {
        syncUserState(true);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        syncUserState(true);
      }
    };

    const handleWindowFocus = () => {
      syncUserState(true);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('focus', handleWindowFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('focus', handleWindowFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return currentUser;
}
